export const appConfig = {
  version: import.meta.env.VITE_APP_VERSION ?? "dev",
  environment: import.meta.env.VITE_APP_ENVIRONMENT ?? "development",
  apiBase: import.meta.env.VITE_CP_API_BASE ?? "",
  isProduction: (import.meta.env.VITE_APP_ENVIRONMENT ?? "development") === "production",
  gitCommit: import.meta.env.VITE_GIT_COMMIT ?? "",
  gitBranch: import.meta.env.VITE_GIT_BRANCH ?? "",
  buildVersion: import.meta.env.VITE_BUILD_VERSION ?? "",
  buildTimestamp: import.meta.env.VITE_BUILD_TIMESTAMP ?? "",
  githubRunId: import.meta.env.VITE_GITHUB_RUN_ID ?? "",
  imageTag: import.meta.env.VITE_IMAGE_TAG ?? "",
} as const;
